import React, { useState } from "react";
import sanctum_axios_client from "../services/sanctum_axios_client";
import axiosClient from "../services/axios_client";


const ApiTester: React.FC = () => {
  const [url, setUrl] = useState("");
  const [response, setResponse] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleTest = async () => {
    if (!url.trim()) {
      setError("Please enter a URL.");
      return;
    }
    setError(null);
    setLoading(true);
    setResponse(null);

    try {
      await sanctum_axios_client.get("/sanctum/csrf-cookie");
      const res = await axiosClient.post(url);
      setResponse(JSON.stringify(res.data, null, 2));
    } catch (err: any) {
      setError(err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <style>
        {`
          .api-tester-container {
            font-family: var(--font-body, Arial, sans-serif);
            padding: 2rem;
            background-color: #f9f9f9;
            height: 100vh;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
          }
          .api-tester-input {
            padding: 0.75rem;
            border: 2px solid var(--color-primary, #537D5D);
            border-radius: 8px;
            font-size: 1rem;
            width: 100%;
            margin-bottom: 1rem;
          }
          .api-tester-button {
            background-color: var(--color-primary, #537D5D);
            color: white;
            padding: 0.75rem 1.5rem;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            font-size: 1rem;
            margin-bottom: 1rem;
            transition: background-color 0.2s ease;
          }
          .api-tester-button:hover {
            background-color: var(--color-secondary, #73946B);
          }
          .api-tester-error {
            color: red;
            margin-bottom: 1rem;
            font-weight: bold;
          }
          .api-tester-response {
            flex: 1;
            overflow-y: auto;
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 8px;
            padding: 1rem;
            font-family: monospace;
            white-space: pre-wrap;
            word-break: break-word;
          }
          .api-tester-loading {
            text-align: center;
            font-weight: bold;
            color: var(--color-primary, #537D5D);
          }
        `}
      </style>

      <div className="api-tester-container">
        <input
          type="text"
          className="api-tester-input"
          placeholder="Enter API URL"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
        <button
          className="api-tester-button"
          onClick={handleTest}
          disabled={loading}
        >
          {loading ? "Testing..." : "Test API"}
        </button>
        {error && <div className="api-tester-error">{error}</div>}
        {loading && <div className="api-tester-loading">Loading...</div>}
        {response && (
          <pre className="api-tester-response">{response}</pre>
        )}
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    height: "100%",
  },
};

export default ApiTester;
